// Player-authored text goes through here before it touches innerHTML.
//
// Character names, night titles, resource names and now-playing metadata
// are all written by people, and three panels were interpolating them
// straight into markup — a character called `<img onerror=...>` would run
// on the game origin, against a session cookie, for everybody who opened
// the poster wall. Sanitising at the source is not enough: the chat
// sanitiser deliberately preserves angle brackets because they are
// legitimate characters to type.

export function escapeHtml(value: unknown): string {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}
